<script setup lang="ts">

import type { IProductBlock } from '~/interfaces/product/IProductBlock';
import {
  TYPE_ASSET_TEXT, TYPE_PICTURE,
  TYPE_STRENGTHS_AND_WEAKNESSES,
  TYPE_TEXT_ASSET, TYPE_VIDEO, TYPE_YOUTUBE_VIDEO
} from '~/constants/product/productBlockConstants';

const props = defineProps<{
  productBlockCollection: IProductBlock[]
}>()

const {
  productBlockCollection
} = toRefs(props)
</script>

<template>
  <div class="product-page__extra-block mb-2">
    <div
        v-for="(productBlockDTO, index) in productBlockCollection"
        :key="index">
      <div v-if="productBlockDTO.type === TYPE_STRENGTHS_AND_WEAKNESSES" class="cwrapper--without-padding">
        <div class="cproduct-block cproduct-block--align-top mt-4">
          <div class="cproduct-block__point">
            <svg class="svg-icon">
              <use xlink:href="#strengths"/>
            </svg>
            <h3>{{ $t('www.product.block.strengths.title') }}</h3>
            <div class="content size--headline" v-html="productBlockDTO.strengths"/>
          </div>
          <div v-if="productBlockDTO.weaknesses !== ''" class="cproduct-block__point">
            <svg class="svg-icon">
              <use xlink:href="#weaknesses"/>
            </svg>
            <h3>{{ $t('www.product.block.weaknesses.title') }}</h3>
            <div class="content size--headline" v-html="productBlockDTO.weaknesses"/>
          </div>
        </div>
      </div>

      <div v-if="productBlockDTO.type === TYPE_TEXT_ASSET || productBlockDTO.type === TYPE_ASSET_TEXT" class="cwrapper--without-padding">
        <div :class="`cproduct-block cproduct-block__text-asset mt-2 ${productBlockDTO.type == TYPE_ASSET_TEXT ? ' cproduct-block--reverse': '' }`">
          <div class="cproduct-block__text size--headline">
            <h3>{{ productBlockDTO.productBlockTextDTO.title }}</h3>
            <div class="cproduct-block__content content" v-html="productBlockDTO.productBlockTextDTO.content"/>
          </div>
          <div :class="`cproduct-block__asset ${ productBlockDTO.productBlockAssetDTO.type == TYPE_PICTURE ? ' image' : '' }`">
            <picture v-if="productBlockDTO.productBlockAssetDTO.type === TYPE_PICTURE">
              <img :alt="productBlockDTO.productBlockTextDTO.title" :src="productBlockDTO.productBlockAssetDTO.url">
            </picture>
            <video v-else-if="productBlockDTO.productBlockAssetDTO.type === TYPE_VIDEO" class="" autoplay playsinline muted loop>
              <source :src="productBlockDTO.productBlockAssetDTO.url" :type="productBlockDTO.productBlockAssetDTO.mimeType">
            </video>
            <iframe
                v-else-if="productBlockDTO.productBlockAssetDTO.type === TYPE_YOUTUBE_VIDEO"
                :src="productBlockDTO.productBlockAssetDTO.url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
